import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Label } from 'semantic-ui-react';

const TotalPill = ({ total, unit, trail, children }) => {
  const desc = `${unit}${total > 1 ? 's' : ''}`;
  return (
    <Grid textAlign="center" className="grid--spreaded">
      <Grid.Column>
        <Label size="large">
          <strong>
            {total} {desc}{' '}
          </strong>
          {trail}
        </Label>
      </Grid.Column>
      {children}
    </Grid>
  );
};

TotalPill.propTypes = {
  total: PropTypes.number,
  unit: PropTypes.string,
  trail: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

export default TotalPill;
